<template>	
	<div class="listTab">
		<div class="search_box">
			<form action="/">
				<!-- <van-search 
				placeholder="搜索人名、标题、内容、状态" 				
				v-model="keyword"
				 @search="onSearch"
				 @keyup="searchKeyup"
				 @clear="clearKeyWord"
				/> -->
				<van-search 
				placeholder="搜索人名、标题、内容、状态、业务编码" 				
				v-model="keyword"
				background="#F5F6F9"
				 @search="onSearch"	
				 @focus="hideTabBar"
				 @blur="showTabBar"
				 show-action				 			 				 
				 @clear="clearKeyWord"				 
				>
					<div slot="action" @click="onSearch">搜索</div>
				</van-search>

			</form>
		</div>

<!-- <van-list 
v-model="loading"
:finished="finished"
finished-text="没有更多了"
@load="onLoadPull"
> -->
		<noDataPage v-if="isNoData" :text="noDataTxt" :url="noDataImg"></noDataPage>
		<div v-else>
			<div v-for="(list,id) in listTab" :key="id">
				<div class="item_bd" @click="listToLink(list.type,list.id)">
					<div class="h3_tit">
						{{list.title}}
						<van-tag class="h3_tag" plain color="#307DCD" v-if="list.status==1">审批中</van-tag>
						<van-tag class="h3_tag" plain color="#4EB240" type="primary" v-if="list.status==2">已通过</van-tag>
						<van-tag class="h3_tag" plain color="#F44545" type="success" v-if="list.status==3">已拒绝</van-tag>
					</div>
					<div class="des_p">申请理由：{{list.apply_reason}}</div>
					<div class="des_p">申请描述：{{list.apply_remark}}</div>
					<div class="date_p">{{list.friendly_time}}</div>		  			
				</div> 
			</div>		
    	</div>
<!-- </van-list>  -->



	    
		<bottomTabBar v-if="isShow" activeNum="/listTabA" />


	</div>
</template>


<script>

import { Search } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Tag } from 'vant';	
import {sendPost} from '../assets/js/api.js'
import bottomTabBar from '@/components/bottomTabBar.vue'
import { List } from 'vant';
import noDataPage from '@/components/noDataPage.vue'

//Vue.use(Tab).use(Tabs);


export default {
  name: 'mySubmit',
  components: {
	bottomTabBar,noDataPage,
  	[Search.name]: Search,
  	[Tag.name]: Tag,  
  	[Cell.name]: Cell,	 
	[List.name]: List    	
	//  ,[TabbarItem.name]: TabbarItem  
  },
  data() {
    return {
		icon: {
			atMe: require('../assets/img/icon/icon-804.png'),//抄送 搜索
			mySearch: require('../assets/img/icon/icon-802.png')       
		},

		isNoData:false,
	  noDataTxt:"",
	  noDataImg:"",
	  keyword:"",
	  active: 0,
      loading: false,
	  finished: false,
	  countee:1,
	  listTab:[],
	  isShow:true
	 
    }
  },
  methods: {
	  	hideTabBar(){			  
			  this.isShow = false;
			  console.log(this.isShow);
			  
		},
		showTabBar(){			 
			  this.isShow = true;
			   console.log(this.isShow);
			  
		},
		onLoadPull() {
		// 异步更新数据		
			console.log("this.loading::::::"+this.loading);
			console.log("this.finished:::::"+this.finished);
			setTimeout(() => {
				this.requestListData(this.keyword,this.countee);
			}, 50);
		},		
	  	onSearch(key_word,page){//搜索事件
			  //console.log(this.active);
			  //console.log(this.keyword);
			  	this.listTab.length = 0;
				this.countee = 1;
				this.loading = false;
				  this.finished = false;	
				   this.isShow = true;			
			  setTimeout(() => {
				  //this.requestListData(this.active+1,this.keyword,this.countee);
					this.onLoadPull();
			  }, 200);			  
		},
		onCancel(){//取消搜索
			  console.log("onCancel");
			  this.isShow = true;
		},
		clearKeyWord(){//清除文字
				this.isShow = true;
			  	this.keyword = "";
				this.listTab.length = 0;
				this.countee = 1;
				this.onLoadPull();
			  //this.requestListData(this.active+1,this.keyword,1);
		},
		requestListData(keyword,page){
			sendPost("api/approval/mylist",{page:page,keyword:keyword}).then(res=>{
				this.isNoData = false;
				let _data = res.data;
				console.log(res);
				if(_data.code==0){
					//console.log("this.countee:::::"+this.countee);
								this.isShow = true;
								this.listTab = _data.data;
								console.log("this.listTab:::::"+this.listTab.length);
								console.log(this.listTab);

								if(this.listTab.length<=0){							
									this.isNoData = true;
								if(keyword==''){
									this.noDataTxt = "暂无数据！";
									this.noDataImg = this.icon.atMe;
								}else{
									this.noDataTxt = "抱歉，暂无搜索结果～";
									this.noDataImg = this.icon.mySearch;
								}
								if(document.getElementsByClassName("van-list__finished-text").length>0){
									for(let i = 0;i<document.getElementsByClassName("van-list__finished-text").length;i++){
											document.getElementsByClassName("van-list__finished-text")[i].innerText = '';
											//console.log(document.getElementsByClassName("van-list__finished-text"));
									}
								}


								/*
								////分页
								if(this.countee<=_data.data.count){
									console.log("rrrr");
									this.listTab = this.listTab.concat(_data.data);								
									this.countee = this.countee + 1;
									//console.log("rrrr");
								}else{
									this.finished = true;
								}
								this.loading=false;
								//数据为空是，显示暂无数据组件						
								if(this.countee<=1){
									if(_data.data.length>0){
										this.isNoData = false;
									}else{
										this.isNoData = true;
										if(key_word==''){
											this.noDataTxt = "暂无数据";
											this.noDataImg = this.icon.atMe;
										}else{
											this.noDataTxt = "抱歉，暂无搜索结果～";
											this.noDataImg = this.icon.mySearch;											
										}
										setTimeout(() => {
											if(document.getElementsByClassName("van-list__finished-text").length>0){
												for(let i = 0;i<document.getElementsByClassName("van-list__finished-text").length;i++){
														document.getElementsByClassName("van-list__finished-text")[i].innerText = '';
														//console.log(document.getElementsByClassName("van-list__finished-text"));
												}
											}
										 }, 100);

									}	
								}
						
							*/
					}							
				}else{
					this.$toast(res.data.msg);
				}				
			});
		},
	  	listToLink(type,id){
			  //alert("type::"+type+"  Id:::"+id);
			if(type==1){
				this.$router.push({path:'/mySubmitDetail',query:{id:id}});
			}else if(type==2){
				this.$router.push({path:'/review',query:{id:id}});
			}			
		  },
  },
  created(){
	  this.requestListData(this.keyword,this.countee);
  }
}	
</script>
<style scoped>
.search_box{background-color: #F5F6F9;padding: 10px 16px}
.search_box .van-search{ padding: 0 0 !important;}
.search_box .van-search__content{ background: #fff; border-radius: 5px;}
.search_box .van-search{border-radius: 5px;}

.item_bd{margin: 10px 12px;padding: 4px 12px;  border-radius: 4px; border: 0.5Px solid #e5e5e5;}
.item_bd .h3_tit{ 
	position: relative;   
    display:block;    
    
    padding:10px 60px 5px 0;
    
    color: #333;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
	font-weight: 600;
    }
    .h3_tag{ position: absolute; top: 10px; right: 0px;}
    .des_p,
    .date_p{    color: #999;
    font-size: 14px;
    height: 26px;
    line-height: 26px; overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;}
	.date_p{ text-align: right; padding-bottom: 5px;}


.van-tabs--line >>> .van-tabs__line{background-color:#307DCD;}


</style>




